import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Theme } from "@carbon/react";

import AppRoutes from "./routes/AppRoutes";

export default function App() {
  return (
    <Theme theme="g10">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Theme>
  );
}